"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lazyload_image_directive_1 = require("./src/lazyload-image.directive");
exports.LazyLoadImageDirective = lazyload_image_directive_1.LazyLoadImageDirective;
var lazyload_image_module_1 = require("./src/lazyload-image.module");
exports.LazyLoadImageModule = lazyload_image_module_1.LazyLoadImageModule;
exports.default = lazyload_image_module_1.LazyLoadImageModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng-lazyload-image/index.js
// module id = 464
// module chunks = 0